export default __webpack_public_path__ + "static/media/361.f8e157c3.jpg";